export function getPolicyState(latest_active_policy, policies) {
  if (latest_active_policy?.program_id) {
    return latest_active_policy.program_id.slice(-2);
  } else {
    return policies[policies.length - 1]?.program_id?.slice(-2);
  }
}
